module.exports = __webpack_public_path__ + "img/home-page-mask-img-desktop.a5e2b631.png";